module.exports = __webpack_public_path__ + "img/sb08.413dfbb7.png";